import { VERDICT_LEVEL, getDocumentVerdict } from "@components/document-intake/document-intake-state";
import React, { useContext, useEffect, useState } from "react";
import { ErrorMessage, Formik } from "formik";
import {
  Alert,
  Button,
  Form,
  Spinner,
  Card,
  Row,
  Col,
  Table,
  Accordion,
  Modal,
} from "react-bootstrap";
import moment from "moment";
import * as Yup from "yup";
import { getInputClasses } from "@utils/get-input-classes";
import AlertError from "@components/shared/alert-error";
import { Divider } from "@material-ui/core";
import { getAllByCase, save } from "@services/documents";
import { GetUser } from "@metronic/_helpers";
import { useAuthStore } from "@stores/auth";

import BlockCaseContext from "@contexts/block-case-context";
import {isNotEmpty} from "@utils/check-object-empty";

const VALIDATION_TEXT = { ok: "CUMPLE CON LAS CARACTERÍSTICAS", note: "CUMPLE CON LAS CARACTERÍSTICAS", review: "VALIDAR" };

/** Resultado de validar la estructura de un documento; sin analisis (carga manual) no hay validacion. */
const ValidationCell = ({ analysis }) => {
  if (!analysis) {
    return <td />;
  }
  const { level, message } = getDocumentVerdict(analysis);
  return (
    <td title={message} className={level === VERDICT_LEVEL.REVIEW ? "text-danger font-weight-bold" : ""}>
      {VALIDATION_TEXT[level]}
    </td>
  );
};

export const Documentation = (props) => {
  return (
    <>
      <Card>
        <Card.Header>
          <Accordion.Toggle
            as={Button}
            variant="link"
            eventKey={props.eventKey}
          >
            Documentación
          </Accordion.Toggle>
          <i className={`fa ${props.icon}`} style={{position:"absolute", right:"0", marginRight:"15px", marginTop:"10px" }}></i>
          <i className={`fa ${props.icone}`} style={{position:"absolute", right:"0", marginRight:"35px", marginTop:"10px" }}></i>
        </Card.Header>
        <Accordion.Collapse eventKey={props.eventKey}>
          <Card.Body>
            <ContentDocumentation {...props} />
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </>
  );
};

export const ContentDocumentation = (props) => {
  return (
    <>
      <Alert
        variant="dark"
        className="text-center mt-4"
        style={{ fontSize: "14px" }}
      >
        Documentacion
      </Alert>

      <Card>
        <Card.Body>
          <FormDocumentation {...props} />
        </Card.Body>
      </Card>
    </>
  );
};

const FormDocumentation = (props) => {
  const { data } = props;
  const { slug } = props.match?.params || props;

  const validationSchema = Yup.object().shape({
    file: Yup.mixed()
      .required("El campo es requerido")
      .test('fileFormat', 'Solo se permiten archivos PDF', (value) => {
        return value && ['application/pdf'].includes(value.type);
      }),
    document_type: Yup.string()
      .required("El campo es requerido"),
  });

  const [userAuth] = useState({ ...GetUser().user });
  const [, setShouldBlockCase] = useContext(BlockCaseContext);
  const [documents, setDocuments] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [currentDocIndex, setCurrentDocIndex] = useState(0);
  const [pdfBlob, setPdfBlob] = useState(null);

  const onSubmit = (values, { setStatus, setSubmitting, resetForm }) => {
    setTimeout(() => {
      let formData = new FormData();
      formData.append("file", values.file);
      formData.append("user_id", userAuth.idUser);
      formData.append("document_type", values.document_type);
      formData.append("slug", slug);
      save(formData)
        .then( response => {
          getAllByCase(data.id).then(data => setDocuments(data.data));
          setShouldBlockCase(false);
          setInitialDocument({ file: "", document_type: ""});
          resetForm();
          setInputKey(Math.random().toString(36));
        })
        .catch( err => setStatus(`Ocurrio algun error al guardar`));
      setSubmitting(false);
    }, 1000);
  }

  useEffect(() => {
    if (isNotEmpty(data)) {
      getAllByCase(data.id).then(data => setDocuments(data.data));
    }
  }, [data]);

  const [initialDocument, setInitialDocument] = useState({ file: "", document_type: ""});

  const typesDocument = props.typesDocument || [
    "Aviso de Accidente", "Carta de Autorización", "Comprobante de seguro o poliza", "Denuncia ante MP",
    "Desvíos Aplicados", "Estudios de Gabinete", "Estudios de Laboratorio", "Estudios que Confirmen DX",
    "Historia Clinica", "Honorarios Médicos", "Identificacion", "Informe Medico Actualizado", "Nota de Evolución",
    "Nota Postquirurgica", "Resumen Medico Actualizado", "Nota de Remisión", "Sabana Quirurgica", "Otro",
  ];

  const [inputKey, setInputKey] = useState("");

  const { authToken: token } = useAuthStore();

  if (props.attachOptions) {
    const other = typesDocument.pop()
    // typesDocument.unshift(other);
    typesDocument.push(...props.typesDocumentToAttach)
    typesDocument.push(other);
  }

  const toHttps = (url) => url?.replace(/^http:\/\//i, 'https://');

  const downloadPDF = (e, urlFile) => {
    e.preventDefault();
    fetch(toHttps(urlFile), {
      headers: {
        'Authorization': `Bearer ${token}`, 
      }
    })
    .then(response => {
      response.blob().then(blob => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.target = "_blank";
        a.click();
      });
    })
  }

  const loadPDF = async (urlFile) => {
    try {
      const response = await fetch(toHttps(urlFile), {
        headers: {
          'Authorization': `Bearer ${token}`, 
        }
      });
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      setPdfBlob(url);
    } catch (error) {
      console.error("Error loading PDF:", error);
    }
  }

  const handleOpenModal = () => {
    if (documents && documents.length > 0) {
      setCurrentDocIndex(0);
      loadPDF(documents[0].url);
      setShowModal(true);
    }
  }

  const handlePrevDocument = () => {
    if (currentDocIndex > 0) {
      const newIndex = currentDocIndex - 1;
      setCurrentDocIndex(newIndex);
      loadPDF(documents[newIndex].url);
    }
  }

  const handleNextDocument = () => {
    if (currentDocIndex < documents.length - 1) {
      const newIndex = currentDocIndex + 1;
      setCurrentDocIndex(newIndex);
      loadPDF(documents[newIndex].url);
    }
  }

  const handleCloseModal = () => {
    setShowModal(false);
    setPdfBlob(null);
  }

  // Validacion de estructura de los documentos que leyo la IA, por documento del caso.
  const analysisByDocumentId = {};
  (props.analyses || []).forEach((analysis) => {
    if (analysis.documentId) {
      analysisByDocumentId[analysis.documentId] = analysis;
    }
  });

  return (
    <>
      <Table responsive striped bordered hover>
        <thead>
          <tr>
            <th>Documento</th>
            <th>Documento</th>
            <th>Pagina</th>
            <th>Usuario</th>
            <th>Fecha</th>
            {props.analyses && <th>Validación documento</th>}
          </tr>
        </thead>
        <tbody>
          {documents?.map( (document, idx) => (
            <tr key={idx}>
              <td>{idx + 1}</td>
              <td>{document.documentType}</td>
              <td><a href={document.url} onClick={(e) => {downloadPDF(e, document.url)}} target="_blank" rel="noopener noreferrer">Ver</a></td>
              <td>{document.userName}</td>
              <td>{moment(document.createdAt).format('DD/MM/YYYY HH:mm:ss A')}</td>
              {props.analyses && <ValidationCell analysis={analysisByDocumentId[document.id]} />}
            </tr>
          ))}
        </tbody>
      </Table>
      <Divider className="mt-5 mb-5" />

      <Button variant="success" onClick={handleOpenModal} disabled={!documents || documents.length === 0}>
        Visualizador de documentos
      </Button>

      {/* Modal para visualizar PDFs */}
      <Modal 
        show={showModal} 
        onHide={handleCloseModal} 
        size="xl"
        centered
        dialogClassName="pdf-viewer-modal"
        style={{ maxWidth: '100%', margin: '10px' }}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {documents && documents[currentDocIndex] ? 
              `${documents[currentDocIndex].documentType} (${currentDocIndex + 1}/${documents.length})` : 
              'Visualizador de documentos'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="pdf-container" style={{ height: '80vh', width: '100%', overflow: 'hidden' }}>
            {pdfBlob ? (
              <object
                data={pdfBlob}
                type="application/pdf"
                width="100%"
                height="100%"
                style={{ display: 'block' }}
              >
                <iframe 
                  src={pdfBlob} 
                  width="100%" 
                  height="100%" 
                  title="PDF Viewer" 
                  style={{ border: 'none', display: 'block' }}
                >
                  Este navegador no soporta PDFs. Por favor descargue el PDF para visualizarlo.
                </iframe>
              </object>
            ) : (
              <div className="d-flex justify-content-center align-items-center" style={{ height: '100%' }}>
                <Spinner animation="border" />
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-between w-100">
            <Button 
              variant="secondary" 
              onClick={handlePrevDocument}
              disabled={currentDocIndex === 0}
            >
              <i className="fa fa-arrow-left"></i> Anterior
            </Button>
            <Button 
              variant="primary" 
              onClick={handleCloseModal}
            >
              Cerrar
            </Button>
            <Button 
              variant="secondary" 
              onClick={handleNextDocument}
              disabled={!documents || currentDocIndex >= documents.length - 1}
            >
              Siguiente <i className="fa fa-arrow-right"></i>
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      <Divider className="mt-5 mb-5" />
      <Formik initialValues={ initialDocument } enableReinitialize={true} validationSchema={validationSchema} onSubmit={onSubmit}>
        {({values, errors, touched, handleChange, handleSubmit, setFieldValue, status, isSubmitting}) => (
          <>
            <AlertError status={status} />

            <Form onSubmit={handleSubmit}>
              <Row hidden={props.disabledAll}>
                <Col>
                  <Form.Group controlId="file">
                    <Form.Label>Archivo</Form.Label>
                    <Form.Control
                      key={inputKey || ''}
                      disabled={props.disabledAll}
                      type="file"
                      name="file"
                      accept="application/pdf"
                      onChange={(event) => {
                        setFieldValue("file", event.currentTarget.files[0]);
                      }}
                      className={`${getInputClasses(touched, errors, "file")}`}
                    />
                    <ErrorMessage name="file">
                      {(msg) => (
                        <Form.Control.Feedback type="invalid">
                          {msg}
                        </Form.Control.Feedback>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Col>

                <Col>
                  <Form.Group controlId="document_type">
                    <Form.Label>Tipo de Documento</Form.Label>
                    <Form.Control
                      disabled={props.disabledAll}
                      as="select"
                      name="document_type"
                      value={values.document_type}
                      onChange={handleChange}
                      className={`${getInputClasses(
                        touched,
                        errors,
                        "document_type"
                      )}`}
                    >
                      <option value="">SELECCIONA UNA OPCIÓN...</option>
                      {typesDocument.map( (typeDocument, idx) => (
                        <option key={idx} value={typeDocument}>{typeDocument}</option>
                      ))}
                    </Form.Control>
                    <ErrorMessage name="document_type">
                      {(msg) => (
                        <Form.Control.Feedback type="invalid">
                          {msg}
                        </Form.Control.Feedback>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Col>
              </Row>
              <Button variant="primary" type="submit" disabled={isSubmitting} hidden={props.disabledAll}>
                {isSubmitting && (
                  <Spinner
                    as="span"
                    animation="border"
                    variant="dark"
                    size="sm"
                  />
                )}
                Subir Documento
              </Button>
            </Form>
          </>
        )}
      </Formik>
    </>
  );
};

export default Documentation;

